export default __webpack_public_path__ + "static/media/019-shopping-basket.c2110ec4.png";